/**
 * Check if single selected company is same as this route company.
 * Used for return route highlighting and pricing
 */
interface IsSameCompanyProps {
    selectedSingleRouteCompanyId: string,
    routeCompanyId: string,
    isReturn: boolean,
    routeId: string,
    singleConfirmedRouteId?: string
}

export default function isSameCompany(props: IsSameCompanyProps): boolean {
    const {
        selectedSingleRouteCompanyId,
        routeCompanyId,
        isReturn,
        routeId,
        singleConfirmedRouteId,
    } = props

    if (selectedSingleRouteCompanyId) {
        return routeId !== singleConfirmedRouteId && selectedSingleRouteCompanyId === routeCompanyId && isReturn
    }

    return false
}